import React, { useEffect, useState } from 'react';
import { z } from 'zod';
import api from 'shared/services/api';
import { toast } from 'react-toastify';
import { useForm } from '@mantine/form';
import { Button, Group, Modal } from '@mantine/core';
import { useTranslations } from 'shared/translations/useTranslations';

import EditInspectionDetailsForm from '../EditInspectionDetailsForm';

const schema = z.object({
  name: z.string(),
  description: z.string().optional(),
});

interface Props {
  onClose: () => any;
  placeId: string | number;
  refreshParent: () => any;
  inspectionId: number;
  open: boolean;
  data: {
    name: string;
    startedAt: string;
    finishedAt: string;
  };
}

interface Data {
  action: {
    deviceTypeAction: {
      name: string;
    };
    note: string;
    amount: number;
    createdAt: string;
  };
}

const EditInspectionDetailsModal = (props: Props) => {
  const { refreshParent, onClose, placeId, inspectionId, open, data } = props;
  const translations = useTranslations();
  const [isSaving, setSaving] = useState(false);

  const form = useForm<{
    name: string;
    startedAt: Date | string | undefined;
    finishedAt: Date | string | undefined;
  }>({
    initialValues: {
      name: '',
      startedAt: undefined,
      finishedAt: undefined,
    },
  });

  useEffect(() => {
    if (open && data) {
      form.setValues({
        name: data.name,
        startedAt: data.startedAt ? new Date(data.startedAt) : undefined,
        finishedAt: data.finishedAt ? new Date(data.finishedAt) : undefined,
      });
    }
  }, [open, data]);

  const handleClose = () => {
    onClose();
    form.reset();
  };

  const onSubmit = async (formValues: any) => {
    setSaving(true);
    try {
      const body = {
        ...formValues,
      };
      await api({}).patch(`/api/places/${placeId}/inspections/${inspectionId}/details`, body);
      toast.success('Detale zostały zaktualizowane');
      setSaving(false);
      handleClose();
      onClose();
      refreshParent();
    } catch (e) {
      setSaving(false);
      toast.error(translations.global.somethingWentWrong);
    }
  };

  return (
    <Modal opened={open} onClose={handleClose} title={'Edytuj detale'} size="lg">
      <form onSubmit={form.onSubmit(onSubmit)} style={{ minHeight: '600px' }}>
        <EditInspectionDetailsForm form={form} />
        <Group position="right" mt={20}>
          <Button color="primary" loading={isSaving} type="submit" disabled={isSaving}>
            {translations.global.edit}
          </Button>
          <Button variant="outline" onClick={handleClose}>
            {translations.global.cancel}
          </Button>
        </Group>
      </form>
    </Modal>
  );
};

export default EditInspectionDetailsModal;
